module.exports = __webpack_public_path__ + "static/media/home_btn.c7200785.svg";